import { isNonEmptyString } from '@/utils/checks'
const callToAction = {
  CALL: 'call',
  EMAIL: 'email',
  MESSAGE: 'message'
}
export const PROVIDERS_WITH_BENEFITS = ['verifyTx', 'aac', 'storybook']

export const shouldDisplayVerificationOfBenefits = (benefitsProvider) =>
  isNonEmptyString(benefitsProvider) &&
  PROVIDERS_WITH_BENEFITS.includes(benefitsProvider)

export const shouldDisplayVerifyInsurance = (verifyInsuranceLink, benefits) =>
  !!(
    verifyInsuranceLink ||
    shouldDisplayVerificationOfBenefits(benefits?.benefitsProvider)
  )
